import { Field, ID, InputType, ObjectType } from 'type-graphql'
import type { IAction } from '../../../action/IAction'
import { ActionArgs } from '../../../action/ActionArgs'
import { PaymentGatewayProviderEnum } from '../../../payment/PaymentGatewayProviderEnum'
import type { PaymentGatewayProvider } from '../../../payment/PaymentGatewayProviderEnum'

@InputType()
export class CreateCreditPurchaseArgs extends ActionArgs {
  @Field(() => ID)
  creditPackageId: string

  @Field(() => String, { nullable: true })
  couponCode?: string

  /** Target owner for this purchase — omitted means the caller buys for themselves. Buying for another user requires the admin permission check. */
  @Field(() => ID, { nullable: true })
  ownerId?: string

  /** Supplied → the caller chose a gateway. Absent → the app's configured default. */
  @Field(() => PaymentGatewayProviderEnum, { nullable: true })
  gatewayProvider?: PaymentGatewayProvider
}

@ObjectType()
@InputType('CreateCreditPurchaseResultInput')
export class CreateCreditPurchaseResult {
  @Field(() => ID)
  purchaseId: string

  /** True when the purchase was settled immediately (fully discounted, no gateway involved). */
  @Field(() => Boolean)
  paid: boolean

  /** Hosted checkout URL to open — absent when `paid` is true. */
  @Field(() => String, { nullable: true })
  checkoutUrl?: string
}

export interface ICreateCreditPurchase extends IAction<CreateCreditPurchaseResult, CreateCreditPurchaseArgs> {}
